import { render, staticRenderFns } from "./DependenciaSugerida.vue?vue&type=template&id=3ac33292&"
import script from "./DependenciaSugerida.vue?vue&type=script&lang=js&"
export * from "./DependenciaSugerida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports